<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="ma-1 mr-10"
        fab
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Course Material"
      text="Add Course Materials"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="materialTypes"
                v-validate="'required'"
                :error-messages="errors.collect('course_material_type')"
                :items="courseMaterialTypes"
                data-vv-name="course_material_type"
                data-vv-as="material type"
                item-text="name"
                item-value="id"
                label="Material Type"
                return-object
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="description"
                v-validate="'required'"
                :error-messages="errors.collect('description')"
                data-vv-name="description"                
                label="Description"
              />
            </v-col>

            <v-col
              v-if="['.pdf','.jpg,.jpeg,.png','.mp3,.ogg'].includes(selectedType)"
              cols="12"
            >
              <helper-file-input
                v-model="file" 
                v-validate="'required'"
                :max-size-in-mb="fileSize"
                :max-number="5"
                :multiple="true"
                data-vv-name="files"
                field-name="files"
                :accept-type="selectedType"
              >
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mx-2"    
                  >
                    Add file
                  </v-btn>
                  <span v-if="selectedType === '.jpg,.jpeg,.png'"> 
                    {{ file ? '' : 'No file chosen (.jpg/.png only)' }}
                  </span>
                  <span v-if="selectedType === '.pdf'"> 
                    {{ file ? '' : 'No file chosen (.pdf only)' }}
                  </span>
                  <span v-if="selectedType === '.mp3,.ogg'"> 
                    {{ file ? '' : 'No file chosen (.mp3/.ogg only)' }}
                  </span>
                  <div
                    v-if="file"
                    class="mt-4"
                  >
                    <p
                      v-for="selectedFile in file.selectedFiles"
                      :key="selectedFile.name"
                      class="mb-0"
                    >
                      <span class="font-weight-bold">{{ selectedFile.name }}</span>
                    </p>
                  </div>
                </div>
              </helper-file-input>
              <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
            </v-col>

            <v-col
              v-if="['link'].includes(selectedType)"
              cols="12"
            >
              <v-btn @click="addRow">
                Add Link
              </v-btn>
      
              <v-row
                v-for="(link, counter) in links"
                :key="counter"
              >
                <v-col
                  cols="10"
                  class="py-0"
                >
                  <v-text-field
                    v-model="link.path"
                    v-validate="'required'"
                    :error-messages="errors.collect('link')"
                    data-vv-name="link"                
                    label="Link"
                  />
                </v-col>
                <v-col
                  cols="2"
                  class="py-0 center-icon"
                >
                  <v-icon
                    color="error"
                    @click="deleteRow(counter)"
                  >
                    mdi-window-close
                  </v-icon>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          v-if="['link'].includes(selectedType)"
          :loading="progressing"
          color="success"          
          @click="submitFormVideo"
        >
          Create
        </v-btn>

        <v-btn
          v-else
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      HelperFileInput: () => import('@/components/helper/FileInput'),
    },
    inject: ['$validator'],
    props: {
      courseId: {
        type: Number,
        default: null,
      },
    },
 
    data () {
      return {
        progressing: false,
        dialog: null,
        name: null,
        description: null,
        materialTypes: null,
        courseMaterialTypes: [],
        file: null,
        links: [
          {
            path: null,
          },
        ],
      }
    },

    computed: {
      fileSize () {
        if (this.selectedType === '.pdf' || this.selectedType === '.jpg,.jpeg,.png') {
          return 2
        }
        return 10
      },
      selectedType () {
        if (!this.materialTypes) return
        return this.materialTypes.extension
      },
    },

    watch: {
      dialog: function (value) {
        if (!value) return
        
        this.resetForm()

        this.$api.courseMaterialTypes().list()
          .then(response => {
            this.courseMaterialTypes = response.data
          })
      },
    },
    methods: {    
      addRow () {
        this.links.push({
          path: '',
        })
      },
      deleteRow (counter) {
        this.links.splice(counter, 1)
      },

      prepareFormDataVideo () {
        return {
          name: this.name,
          description: this.description,
          course_material_type_id: this.materialTypes.id,
          links: this.links,
        }
      },

      submitFormVideo () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true

            this.$api.courseMaterials().create(this.courseId, this.prepareFormDataVideo())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Course Material Added Succesfully' })

                  this.dialog = false                
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },

      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.courseMaterials().create(this.courseId, this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Course Material Added Succesfully' })

                  this.dialog = false                
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },

      prepareFormData () {
        if (this.file) {
          this.file.formData.set('name', this.name)
          this.file.formData.set('description', this.description)
          this.file.formData.set('course_material_type_id', this.materialTypes.id)

          return this.file.formData
        }

        let formData = new FormData()

        this.file.formData.set('name', this.name)
        this.file.formData.set('description', this.description)
        this.file.formData.set('course_material_type_id', this.materialTypes.id)

        return formData
      },

      resetForm () {
        this.name = null
        this.description = null
        this.materialTypes = null
        this.file = null
        this.links.map(item => {
          item.path = null
        })
        this.$validator.reset()
      },
    },
  }
</script>

<style scoped>
.center-icon{
    margin:auto
}
</style>
